import { render, staticRenderFns } from "./CustomSvgIcon.vue?vue&type=template&id=4b9868e6"
import script from "./CustomSvgIcon.vue?vue&type=script&lang=ts"
export * from "./CustomSvgIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports